<div class="gb-callout">
  <mat-card [ngClass]="color ? 'card-' + color : ''">
    <mat-card-title *ngIf="title">
      {{ title | translate }}
    </mat-card-title>
    <mat-card-content>
      <ng-content></ng-content>
    </mat-card-content>
  </mat-card>
</div>
